import ApiClient from './apiClient';

export interface ApiToken {
  id: number;
  name: string;
  abilities: string[];
  last_used_at: string | null;
  expires_at: string | null;
  is_active: boolean;
  created_at: string;
}

export interface CreateApiTokenData {
  name: string;
  abilities: string[];
  expires_at?: string | null;
}

export interface CreateApiTokenResponse {
  id: number;
  name: string;
  token: string;
  abilities: string[];
  expires_at: string | null;
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
}

const apiTokenService = {
  listTokens: async (): Promise<ApiToken[]> => {
    const response = await ApiClient.get<ApiResponse<ApiToken[]>>('/api-tokens');
    return response.data;
  },

  createToken: async (data: CreateApiTokenData): Promise<CreateApiTokenResponse> => {
    const response = await ApiClient.post<ApiResponse<CreateApiTokenResponse>, CreateApiTokenData>(
      '/api-tokens',
      data
    );
    return response.data;
  },

  toggleToken: async (id: number): Promise<{ id: number; is_active: boolean }> => {
    const response = await ApiClient.patch<ApiResponse<{ id: number; is_active: boolean }>>(
      `/api-tokens/${id}/toggle`
    );
    return response.data;
  },

  revokeToken: async (id: number): Promise<void> => {
    await ApiClient.delete(`/api-tokens/${id}`);
  },
};

export default apiTokenService;
